import { Chain } from 'viem/chains';
import { mainnet, mode, optimism, arbitrum, base, polygon, blast, avalanche, bsc, scroll } from 'wagmi/chains';

import { AVAILABLE_RPC } from 'mode-shared/constants/rpcs';
import localConfig from 'mode-shared/configs/config';
import { RPC_OVERRIDE_KEY_L1, RPC_OVERRIDE_KEY_L2 } from 'mode-shared/constants/common';
import {
  holeskyUpdated,
  mainnetUpdated,
  mode as modeMainnet,
  modeTestnet,
  optimismUpdated,
  sepoliaUpdated,
} from 'mode-shared/configs/mode';
import { getActiveRpc } from 'mode-shared/utils/wallet';

const modeBlastRpc = AVAILABLE_RPC[mode.id].find((item) => item.label === 'BlastAPI');
const mainnetBlastRpc = AVAILABLE_RPC[mainnet.id].find((item) => item.label === 'BlastAPI');
const optimismBlastRpc = AVAILABLE_RPC[optimism.id].find((item) => item.label === 'BlastAPI');

const modeTestnetCustom = {
  ...modeTestnet,
  iconUrl: '/assets/icons/mode_yellow.svg',
};

const modeMainnetCustom = {
  ...mode,
  blockExplorers: modeMainnet.blockExplorers,
  iconUrl: '/assets/icons/mode_yellow.svg',
  rpcUrls: getActiveRpc(
    RPC_OVERRIDE_KEY_L2,
    modeBlastRpc
      ? {
          default: {
            http: modeBlastRpc.value,
          },
          public: {
            http: modeBlastRpc.value,
          },
        }
      : mode.rpcUrls
  ),
};

const mainnetCustom = {
  ...mainnet,
  rpcUrls: getActiveRpc(
    RPC_OVERRIDE_KEY_L1,
    mainnetBlastRpc
      ? {
          default: {
            http: mainnetBlastRpc.value,
          },
          public: {
            http: mainnetBlastRpc.value,
          },
        }
      : mainnetUpdated.rpcUrls
  ),
};

const optimismCustom = {
  ...optimism,
  rpcUrls: getActiveRpc(
    RPC_OVERRIDE_KEY_L2,
    optimismBlastRpc
      ? {
          default: {
            http: optimismBlastRpc.value,
          },
          public: {
            http: optimismBlastRpc.value,
          },
        }
      : optimismUpdated.rpcUrls
  ),
};

const scrollCustom = {
  ...scroll,
  iconUrl: '/assets/icons/scroll-chain.svg',
};

const sepoliaCustom = {
  ...sepoliaUpdated,
  rpcUrls: getActiveRpc(RPC_OVERRIDE_KEY_L1, sepoliaUpdated.rpcUrls),
};

const holeskyCustom = {
  ...holeskyUpdated,
  rpcUrls: getActiveRpc(RPC_OVERRIDE_KEY_L1, holeskyUpdated.rpcUrls),
};

const mainnetChains = [
  modeMainnetCustom,
  mainnetCustom,
  optimismCustom,
  holeskyCustom,
  arbitrum,
  base,
  polygon,
  blast,
  avalanche,
  bsc,
  scrollCustom,
] as [Chain, ...Chain[]];
const testnetChains = [modeTestnetCustom, sepoliaCustom] as [Chain, ...Chain[]];

export const chains: [Chain, ...Chain[]] = (() => {
  if (localConfig.l1ChainId === '1') {
    return mainnetChains;
  } else {
    return [...mainnetChains, ...testnetChains];
  }
})();
